import { Page } from "../components/Layout";
import { AboutTeaser, ClientsMarquee, HomeDeployments, HomeCta, HomeHero, MetricsSection, ProcessSection, ServicesOverview, WhyUsSection } from "../components/home/HomeSections";

export default function Home() {
  return (
    <Page testId="home-page">
      <HomeHero />
      <MetricsSection />
      <ClientsMarquee />
      <AboutTeaser />
      <ServicesOverview />
      <ProcessSection />
      <WhyUsSection />
      <HomeDeployments />
      <HomeCta />
    </Page>
  );
}
